import { render, staticRenderFns } from "./MobileMainEvents.vue?vue&type=template&id=50a622a8"
import script from "./MobileMainEvents.vue?vue&type=script&lang=js"
export * from "./MobileMainEvents.vue?vue&type=script&lang=js"
import style0 from "./MobileMainEvents.vue?vue&type=style&index=0&id=50a622a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports